import { render, staticRenderFns } from "./CoursesEdit.vue?vue&type=template&id=f6fa228a"
import script from "./CoursesEdit.vue?vue&type=script&lang=js"
export * from "./CoursesEdit.vue?vue&type=script&lang=js"
import style0 from "./CoursesEdit.vue?vue&type=style&index=0&id=f6fa228a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports